import mitt from 'mitt';

const emitter = mitt<{
  itemCreated: { id: string };
  topicSynced: { id: string };
  itemSynced: { id: string };
  topicSelected: { topicId: string };
  folderSelected: { folderId: string };
  itemVisibilityChanged: undefined;
}>();

export const useLibraryDomain = () => {
  function createItem(id: string) {
    emitter.emit('itemCreated', { id });
  }

  function onItemCreated(cb: (params: { id: string }) => void) {
    emitter.on('itemCreated', cb);
  }

  function syncTopic(id: string) {
    emitter.emit('topicSynced', { id });
  }

  function onTopicSynced(cb: (params: { id: string }) => void) {
    emitter.on('topicSynced', cb);
  }

  function syncItem(id: string) {
    emitter.emit('itemSynced', { id });
  }

  function onItemSynced(cb: (params: { id: string }) => void) {
    emitter.on('itemSynced', cb);
  }

  function selectTopic(topicId: string) {
    emitter.emit('topicSelected', { topicId });
  }

  function onTopicSelected(cb: (params: { topicId: string }) => void) {
    emitter.on('topicSelected', cb);
  }

  function onItemVisibilityChanged(cb: () => void) {
    emitter.on('itemVisibilityChanged', cb);
  }

  function changeItemVisiblity() {
    emitter.emit('itemVisibilityChanged');
  }

  return {
    createItem,
    onItemCreated,
    syncTopic,
    onTopicSynced,
    syncItem,
    onItemSynced,
    selectTopic,
    onTopicSelected,
    onItemVisibilityChanged,
    changeItemVisiblity,
  };
};
